import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FwContainedInputComponent,
  FwDialogActionsComponent,
  FwDialogComponent,
  FwDialogContentComponent,
  FwDialogHeaderComponent,
  FwDialogService,
  FwIconComponent,
  FwSectionHeadingComponent,
  FwTabPanelComponent,
  FwTooltipDirective,
} from '@flywheel-io/vision';

import { MaterialModule } from '../material.module';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { BatchJobDialog } from './batch-job-dialog/batch-job-dialog.component';
import { FileBrowserDialog } from './file-browser/file-browser-dialog.component';
import { GearService } from './gear.service';
import { GearAccessDialogComponent } from './gear-access-dialog/gear-access-dialog.component';
import { GearConfigComponent } from './gear-config/gear-config.component';
import { GearInfoComponent } from './gear-info/gear-info.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FwDialogActionsComponent,
    FwDialogComponent,
    FwDialogContentComponent,
    FwDialogHeaderComponent,
    FwIconComponent,
    FwTabPanelComponent,
    FwTooltipDirective,
    GearConfigComponent,
    GearInfoComponent,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    SharedModule,
    FwContainedInputComponent,
    FwSectionHeadingComponent,
    GearAccessDialogComponent,
  ],
  declarations: [BatchJobDialog, FileBrowserDialog],
  providers: [FwDialogService, GearService],
})
export class GearModule {}
